import { nodeArray } from 'meteora';
var Macy = require('macy');
document.addEventListener('DOMContentLoaded', function () {
  nodeArray(document.querySelectorAll('.js-macy')).forEach(function (group) {
    group.Macy = Macy({
      container: group,
      columns: 1,
      trueOrder: true,
      mobileFirst: true,
      breakAt: {
        640: {
          columns: 2
        },
        960: {
          columns: 3
        }
      }
    });
  });
});